import EventCard from '@/league/components/EventCards/EventCard';
import SportIcons from '@/assets/img/SportIcons.vue';
import EventButton from '@/league/components/main/EventButton.vue';
import ImageComponent from '@/components/base-components/ImageComponent.vue';
import {CARD_RATIO, IMAGE_RATIO} from '@/const';

export default {
  name: 'eventPoster',
  extends: EventCard,
  components: {SportIcons, EventButton, ImageComponent},
  ratio: IMAGE_RATIO,
  cardRatio: CARD_RATIO,
  props: {
    buttonNeed: {
      type: Boolean,
      default: true,
    },
    timeNeed: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    projectSetting() {
      return this.$projectSettings?.components?.eventPoster;
    },
    texts() {
      return {
        playoff: this.projectSetting?.text?.playoff || 'PLAYOFF',
      };
    },
    sportIconNeed() {
      const settings = this.projectSetting?.sportIconNeed;
      const need = typeof settings === 'boolean' ? settings : true;
      return need && this.sport;
    },
    cssVars() {
      const vars = {};
      if (!this.sportIconNeed) {
        vars['--event-card_header-template'] = '1fr';
      }
      return vars;
    },
  },
};
